import React from 'react';
// @ts-ignore
import UI5LoadingCircle from "../../../loading/loading-circle/loading-circle";
import Attachment from "../../../../model2/attachment/attachment";

// const debug = "AttachmentViewUploadNoPreview"
const debug = false

type Props = {
    attachment      : Attachment
    onRemove?       : callback
    onAddToMessage? : callback
}

export default class AttachmentViewUploadNoPreviewSmall extends React.Component<Props> {


    constructor(props: Props) {
        super(props)
    }

    componentDidMount() {
        gd.bus.subscribe(this.props.attachment.fileId+'-progress', this, this.onUploadProgress);
        gd.bus.subscribe(this.props.attachment.fileId+'-upload-done', this, this.onUploadProgress);
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this)
    }

    onUploadProgress() {
        // console.log("onUploadProgress", params)
        this.forceUpdate()
    }

    onRemoveClick = (e: React.SyntheticEvent) => {

        e.stopPropagation()

        if (this.props.onRemove) this.props.onRemove(this.props.attachment)
    }

    onAddToMessageClick = () => {
        if (this.props.onAddToMessage) this.props.onAddToMessage(this.props.attachment)
    }

    render() {

        debug && console.log(debug, "render()", this.props)

        const {attachment} = this.props;
        let icon;
        let label;
        let actions;

        switch (this.props.attachment.dropzoneFile.status) {

            case "added":

                // icon = <img src="/app/web/skin/common/loader/img-loading.gif" width="18" alt="loading"/>
                icon = <UI5LoadingCircle value={0} />
                label = "Preparing for upload..."

                actions = (
                    <div className="overlay-actions">
                        <div className="actions">
                            <div className="ui5-ico-round red i5-trash-alt" onClick={this.onRemoveClick} />
                        </div>
                    </div>
                )
                break;

            case "uploading":

                const progress = Math.ceil(this.props.attachment.dropzoneFile.upload.progress)
                // icon = <img src="/app/web/skin/common/loader/img-loading.gif" width="18" alt="loading" />
                icon = <UI5LoadingCircle value={progress} />
                label = "Uploading... "+progress+"%"

                actions = (
                    <div className="overlay-actions">
                        <div className="actions">
                            <div className="ui5-ico-round red i5-trash-alt" onClick={this.onRemoveClick}/>
                        </div>
                    </div>
                )
                break;

            default:

                icon = <div className="ui5-ico-14 i5-attachment"/>
                label = this.props.attachment.name

                const canInsertInMessage = !attachment.inMessageRTF && this.props.onAddToMessage

                actions = (
                    <div className="overlay-details">
                        {!canInsertInMessage && <div
                            className="file-size ui5-txt-not-important-tiny m-l-10 ">{this.props.attachment.fileSizeFormatted}</div>}
                        <div className="actions">
                            {attachment.inMessageRTF && <div className="ui5-ico-round red size-18 i5-delete"
                                                             onClick={this.onRemoveClick}/>}
                            {canInsertInMessage &&
                                <div className="ui5-link-tiny m-r-10" onClick={this.onAddToMessageClick}>
                                    Insert in Message
                                </div>
                            }
                            {!attachment.inMessageRTF &&
                                <div className="ui5-ico-round red i5-trash-alt" onClick={this.onRemoveClick}/>
                            }
                        </div>
                    </div>
                )
                break;
        }

        return (
            <div className="ui5-attachment-no-preview-small">
                <div className="preview">
                    {icon}
                </div>
                <div className="details">
                    <div className="file-name ui5-txt-less-important-tiny txt-truncate">{label}</div>
                </div>

                {actions}

            </div>
        )
    }
}
